import { owcTheme } from '@one/design-tokens/js/regular/navify/light';
import styled from 'styled-components';

export const NoConnectionLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${owcTheme['one-spacing-base-2']};
  text-align: center;

  margin: auto;
  padding: ${owcTheme['one-spacing-base-4']};

  img {
    max-height: 25vh;
  }
`;

export const NoConnectionStatus = styled.div`
  display: flex;
  align-items: center;
  gap: ${owcTheme['one-spacing-base-2']};
  padding-top: ${owcTheme['one-spacing-base-2']};
`;
